import type { PersistedTab } from 'apiConnector/tabs/tabs.model';
import type { AppState } from 'state/state.model';

import type { WorkspaceTab } from '../tabs/tabs.model';
export function getWorkspaceStaticTabQuoteId(state: AppState, tabId: string) {
  return state.workspaces.static[tabId]?.quoteId;
}

const emptyArray: string[] = [];

export function getWorkspaceStaticTabAiGeneratedFields(state: AppState, tabId: string) {
  return state.workspaces.static[tabId]?.aiGeneratedFields ?? emptyArray;
}

export function getPersistedTabFromStaticWorkspaceTab(state: AppState, tab: WorkspaceTab): PersistedTab {
  const quoteId = getWorkspaceStaticTabQuoteId(state, tab.id);
  return { ...tab, tabContentType: 'primary', quoteId } as PersistedTab;
}

export function getWorkspaceStaticTabProductVariation(state: AppState, tabId: string) {
  return state.workspaces.static[tabId]?.productVariation;
}

export function getWorkspaceStaticTabClient(state: AppState, tabId: string) {
  return state.workspaces.static[tabId]?.client;
}

export function getWorkspaceStaticTabProductValidation(state: AppState, tabId: string) {
  return state.workspaces.static[tabId]?.isProductValidated;
}
export function getIsWorkspaceStaticTabContentFetching(state: AppState, tabId: string) {
  return state.workspaces.static[tabId]?.isFetchingTabContent;
}
